export default function NotFoundPage() {
  return (
    <div className="max-w-3xl mx-auto w-full px-4 py-16 text-center">
      <h1 className="text-2xl font-bold font-unbounded text-[#293545]">
        Страница не найдена
      </h1>
      <p className="mt-2 text-zinc-600 font-onest">
        Откройте форму по адресу <code>/forms/:formId</code>
      </p>
    </div>
  );
}
